import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { ComponentCanDeactivate } from '../../interfaces/component-can-deactivate';
import { Observable } from 'rxjs/internal/Observable';
import { MessageSeverity } from '../../enums/message-severity';
import { AppService } from '../../services/app.service';
import { of } from 'rxjs/internal/observable/of';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class PendingChangesGuardService implements CanDeactivate<ComponentCanDeactivate> {

    public constructor(private appService: AppService) { }

    public canDeactivate(component: ComponentCanDeactivate) {

        let result: boolean | Observable<boolean> = component.canDeactivate();

        if (!result) { // there are pending changes

            const subject = new Subject<boolean>()

            this.appService.showDialog(MessageSeverity.Warning, "Pending Changes !", "There are pending changes that have not been saved.  Are you sure you want to discard your changes ?", "YES I AM SURE, DISCARD CHANGES", "NO, RETURN AND CONTINUE EDITING", false, false).subscribe((response: string) => {

                if (response == "YES I AM SURE, DISCARD CHANGES") {

                    subject.next(true);
                    subject.complete();
                }
            });

            return subject.asObservable();
        }

        return result;
    }

}
